/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from "react-redux";
import { getProfile } from "../actions/user";
import { Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// reactstrap components
import { Container } from "reactstrap";

// core components
import Sidebar from "../components/Sidebar/UserSidebar.jsx";

import routes from "../userroutes.js";
import PageNotFound from "../views/PageNotFound";
import UserArticlesEdit from "../views/profile/EditArticle.jsx";
import UserArticlesNew from "../views/profile/NewArticle.jsx";
import UserForumEdit from "../views/profile/EditForum.jsx";
import UserForumNew from "../views/profile/NewForum.jsx";
import UserAdvs from "../views/profile/Advs.jsx";
import UserAdvEdit from "../views/profile/EditAdv.jsx";
import UserAdvNew from "../views/profile/NewAdv.jsx";

import { Helmet } from "react-helmet";
const Close = ({ closeToast }) => (
  <button className="close" aria-label="Close" onClick={closeToast}>
    <span aria-hidden="true">×</span>
  </button>
);
class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getProfile("user");
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.user.selectedUser !== this.props.user.selectedUser) {
  //     let article = newProps.user.selectedUser;
  //     if (article.role.id < 600) {
  //       this.setState({ croppedImageUrl: DOMAIN + article.cover_image });
  //     }

  //   }
  // }

  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/dash/user") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    let { selectedUser } = this.props.user;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>用戶客戶端 - 美南新聞</title>
          {/* <link rel="canonical" href="https://soonbus.com/login" /> */}
        </Helmet>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/",
            imgSrc: require("../assets/img/brand/logo.png"),
            imgAlt: "..."
          }}
          selectedUser={selectedUser}
        />
        <div className="main-content" ref="mainContent">
          <ToastContainer autoClose={6 * 1000} closeButton={<Close />} />
          <Switch>
            {this.getRoutes(routes)}
            <Route
              exact
              path="/dash/user/management/articles/:id/edit"
              component={UserArticlesEdit}
            />
            <Route
              exact
              path="/dash/user/management/articles/new"
              component={UserArticlesNew}
            />
            <Route
              exact
              path="/dash/user/management/forums/:id/edit"
              component={UserForumEdit}
            />
            <Route
              exact
              path="/dash/user/management/forums/new"
              component={UserForumNew}
            />
            <Route
              exact
              path="/dash/user/management/advs"
              component={UserAdvs}
            />
            <Route
              exact
              path="/dash/user/management/advs/:id/edit"
              component={UserAdvEdit}
            />
            <Route
              exact
              path="/dash/user/management/advs/new"
              component={UserAdvNew}
            />
            <Route component={PageNotFound} />
          </Switch>

          <Container fluid></Container>
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: params => dispatch(getProfile(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User);
